import React, { useState } from 'react';
import { contactAPI } from '../../services/api';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await contactAPI.submit(formData);
      if (response.data.success) {
        setSubmitted(true);
        setFormData({ name: '', email: '', subject: '', message: '' });
        setTimeout(() => {
          setSubmitted(false);
        }, 3000);
      }
    } catch (error) {
      console.error('Error submitting contact form:', error);
      alert('There was an error submitting your message. Please try again.');
    }
  };

  return (
    <div className="contact-page">
      <section className="contact-hero">
        <div className="container">
          <h1>Contact Us</h1>
          <p>Get in touch with our team for expert legal and advisory services</p>
        </div>
      </section>

      <section className="section contact-content">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>Get in Touch</h2>
              <p>
                We are here to help you with all your corporate, legal, and secretarial needs. 
                Reach out to us through any of the following ways.
              </p>

              <div className="contact-details">
                <div className="contact-item">
                  <h3>Head Office</h3>
                  <p>Mumbai.<br />
                    Maharashtra, India
                  </p>
                </div>

                <div className="contact-item">
                  <h3>Contact Information</h3>
                  <p>
                    <strong>Email:</strong> info@carmanya.com<br />
                    <strong>Phone:</strong> +91 xxx
                  </p>
                </div>

                <div className="contact-item">
                  <h3>Working Hours</h3>
                  <p>
                    <strong>Monday - Friday:</strong> 9:30 a.m. to 6:00 p.m.<br />
                    <strong>Sunday & Public Holidays:</strong> Closed
                  </p>
                </div>

                <div className="contact-item">
                  <h3>Other Locations</h3>
                  <p>
                    We are present across India. Contact us to find our office nearest to you.
                  </p>
                </div>
              </div>
            </div>

            <div className="contact-form-container">
              <h2>Send us a Message</h2>
              {submitted ? (
                <div className="form-success">
                  <p>Thank you for your message! We'll get back to you soon.</p>
                </div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="name">Your Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Your Email *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="subject">Subject *</label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Your Message (Optional)</label>
                    <textarea
                      id="message"
                      name="message"
                      rows="6"
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  <button type="submit" className="btn btn-primary">
                    Send Message
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
